import {
  Button,
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Stack,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useForm } from "react-hook-form";
import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import BusinessIcon from "@mui/icons-material/Business";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { VENDORS } from "../../component/common/Routes/AppRoutes";
import ControlledInputField from "../../component/ui/FormFields/ControlledTextInputField";
import CustomButton from "../../component/ui/FormFields/Button";
import StatusRadioGroup from "../../component/ui/FormFields/StatusRadioGroup";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import {
  fetchVendorDetailsRequest,
  resetVendorState,
  updateVendorRequest,
} from "../../redux/Vendors/actions/vendorActions";
import { toast, ToastContainer } from "react-toastify";
import {
  selectCityRequest,
  selectCountryRequest,
  selectStateRequest,
} from "../../redux/Common/selectorAction";
import Loading from "../../component/ui/Loading";
import { convertImageToBase64, isBase64 } from "../../Style";

export default function UpdateVendor() {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const tab = location.state?.tabEdit ?? null;
  
  const page= location.state?.pageEdit??null;
  const {
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      agency_name: "",
      user_id: "",
      first_name: "",
      last_name: "",
      email: "",
      address1: "",
      address2: "",
      phone: "",
      pan_number: "",
      commission_rate: "",
      gstin_number: "",
      pincode: "",
      country_code: "",
      city: "",
      state: "",
      country: "",
      status: "",
      proof_image: "",
      iata_reg_no: "",
    },
  });
  const [selectedFileName, setSelectedFileName] = useState("");
  const { data: vendorData, error } = useSelector(
    (state) => state.vendors.vendorDetails
  );
  const viewLoading = useSelector(
    (state) => state.vendors.vendorDetails?.loading
  );
  const editLoading = useSelector(
    (state) => state.vendors.vendorDetails?.updateLoading
  );

  const success = useSelector((state) => state.vendors.vendorDetails.success);

  useEffect(() => {
    if (id) {
      dispatch(selectCountryRequest());
      dispatch(fetchVendorDetailsRequest(id));
    }
  }, [id]);
  useEffect(() => {
    dispatch(resetVendorState());
  }, []);
  useEffect(() => {
    if (vendorData) {
      reset({
        agency_name: vendorData.agency_name || "",
        first_name: vendorData.first_name || "",
        last_name: vendorData.last_name || "",
        user_id: vendorData.user_id || "",
        email: vendorData.email || "",
        address1: vendorData.address1 || "",
        address2: vendorData.address2 || "",
        phone: vendorData.phone || "",
        pan_number: vendorData.pan_number || "",
        discount: vendorData?.discount || "",
        gstin_number: vendorData.gstin_number || "",
        pincode: vendorData.pincode || "",
        country_code: vendorData.country_code
          ? {
              label: vendorData?.country_code,
              value: vendorData?.country_code,
            }
          : null,
        city: vendorData?.city
          ? {
              label: vendorData?.city_name.replace("_", " "),
              value: vendorData?.city,
            }
          : null,
        state: vendorData.state
          ? {
              label: vendorData.state_name.replace("_", " "),
              value: vendorData.state,
            }
          : null,
        country: vendorData.country
          ? {
              label: vendorData.country_name.replace("_", " "),
              value: vendorData.country,
            }
          : null,
        status: vendorData.status === 1 ? "Active" : "Inactive" || "",
        documents: vendorData.proof_image || "",
        company_reg_number: vendorData?.company_reg_number || "",
        iata_reg_no: vendorData?.iata_reg_no || "",
      });

      setSelectedFileName(vendorData.proof_image ? "Existing Document" : "");
    }
  }, [vendorData]);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setValue("documents", reader.result);
        setSelectedFileName(file.name);
      };
      reader.onerror = (error) => {
        console.error("Error converting file: ", error);
      };
    }
  };

  function extractBase64(input) {
    let result = input; // Get the part after "base64,"
    if (result && result.includes("base64")) {
      result = input.split(/base64,/i)[1];
    }
    if (result && result.includes("pngbase64")) {
      // Remove any unwanted non-Base64 characters before actual Base64 data
      result = result.split(/dataimage\/pngbase64/i)[1];
    }

    return result;
  }

  const validateIndianFields = () => {
    if (countryId === 101) {
      // For India, check if at least one of PAN or GSTIN is provided
      if (!formValue.pan_number && !formValue.gstin_number) {
        setError("pan_number", {
          type: "manual",
          message: "Either PAN or GSTIN is required",
        });
        setError("gstin_number", {
          type: "manual",
          message: "Either PAN or GSTIN is required",
        });
        return false;
      }
    }
    return true;
  };
  const onSubmit = async (data) => {
    if (!data?.documents) {
      toast.error("Document is Required", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    }
    try {
      // const base64Image = data?.documents
      //   ? await convertImageToBase64(data?.documents)
      //   : null;
      if (!validateIndianFields()) {
        return;
      }

      const updatedData = {
        ...data,
        id: id,
        city: data.city?.value || data.city,
        state: data.state?.value || data.state,
        country: data.country?.value || data.country,
        user_id: data.user_id,
        status: data.status === "Active" ? "1" : "0",
        country_code: data.country_code?.value,
        proof_image:
          data?.documents && isBase64(extractBase64(data.documents))
            ? extractBase64(data.documents)
            : null,
        profile_url: "",
      };
      dispatch(updateVendorRequest(updatedData));
    } catch (error) {
      console.error("Error in onSubmit:", error);
    }
  };
  useEffect(() => {
    if (error) {
      if (error.message === "An error occurred while updating vendor") {
        toast.error("An error occured while updating vendor!", {
          autoClose: 3000,
          position: "top-center",
        });
      }
      if (
        error.message ===
        "This email id already added in different mobile number"
      ) {
        setError("email", {
          type: "server",
          message: "This email id already added in different mobile number",
        });
      }
      if (
        error.message ===
        "This mobile number already added in different email id"
      ) {
        setError("phone", {
          type: "server",
          message: "This mobile number already added in different email id",
        });
      }
    }
  }, [error]);
  useEffect(() => {
    if (success) {
      toast.success("Vendor Updated Successfully!", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          navigate(VENDORS);
          dispatch(resetVendorState());
        },
      });
    }
  }, [success]);
  const formValue = watch();
  const country = watch("country");
  const state = watch("state");
  const countryId = country?.value;

  const stateId = state?.value;
  const panNumber = formValue.pan_number;
  const gstinNumber = formValue.gstin_number;
  const countries = useSelector((state) => state.selector?.country?.data);
  const states = useSelector((state) => state.selector?.state?.data);
  const cities = useSelector((state) => state.selector?.city?.data);
  const countryForCode = countries?.map((value) => {
    return {
      label: ` +${value.phonecode} - ${value.short_name}`,
      value: value.phonecode,
    };
  });

  const countryName = countries?.map((country) => {
    return { value: country?.id, label: country?.country_name };
  });
  const stateName = states?.map((state) => {
    return { value: state?.id, label: state?.state_name };
  });
  const cityName = cities?.map((city) => {
    return { value: city?.id, label: city?.city_name };
  });
  const stateCount = useRef(0);
  const cityCount = useRef(0);
  useEffect(() => {
    if (countryId === 101) {
      if (panNumber || gstinNumber) {
        clearErrors(["pan_number", "gstin_number"]);
      }
      if (
        (panNumber === "" && gstinNumber === "") ||
        (panNumber === undefined && gstinNumber === undefined)
      ) {
      }
    }
  }, [panNumber, gstinNumber, countryId, clearErrors]);
  useMemo(() => {
    if (countryId > 0 && stateCount.current > 0) {
      setValue("state", "");
      setValue("city", "");
    }
    if (countryId > 0) {
      dispatch(selectStateRequest(countryId));
      stateCount.current += 1;
    }
  }, [countryId]);

  useMemo(() => {
    if (stateId > 0 && cityCount.current > 0) {
      setValue("city", "");
    }
    if (stateId > 0) {
      dispatch(selectCityRequest(stateId));
      cityCount.current += 1;
    }
  }, [stateId]);
  const documentsField = {
    name: "documents",
    label: "Upload Document *",
    type: "file",
    placeholder: "Upload your document",
    rules: {
      required: "Document upload is required",
      validate: {
        acceptedFormats: (files) => {
          if (!files || files.length === 0) return "Please upload a document";
          const allowedTypes = [
            "image/jpeg",
            "image/png",
            "image/gif",
            "image/jpg",
            "application/pdf",
          ];
          return (
            allowedTypes.includes(files[0]?.type) ||
            "Only JPEG, PNG, GIF images and PDF files are allowed"
          );
        },
      },
    },
    icon: <UploadFileIcon />,
    sm: 6,
    xs: 12,
    customRender: ({ name }) => (
      <Box
        display="flex"
        alignItems="center"
        width="100%"
        sx={{
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "10px",
          backgroundColor: "white",
        }}
      >
        <input
          type="file"
          onChange={handleFileUpload}
          accept="image/jpeg,image/png,image/gif,image/jpg,application/pdf"
          style={{ display: "none" }}
          id="upload-documents"
        />
        <label htmlFor="upload-documents" style={{ flexGrow: 1 }}>
          <Button
            component="span"
            variant="outlined"
            startIcon={<UploadFileIcon />}
            sx={{
              textTransform: "none",
              width: "100%",
              justifyContent: "flex-start",
            }}
          >
            {selectedFileName ? selectedFileName : "Upload Document *"}
          </Button>
        </label>
        {selectedFileName && (
          <IconButton
            size="small"
            onClick={() => {
              setValue(name, null);
              setSelectedFileName("");
            }}
            sx={{
              marginLeft: 1,
              backgroundColor: "rgba(0,0,0,0.1)",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.2)" },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
    ),
  };

  const vendorFields = [
    {
      name: "agency_name",
      label: "Agency / Company Name *",
      placeholder: "Enter your agency name",
      rules: { required: "Agency / Company Name is required" },
      icon: <BusinessIcon />,
      sm: 6,
      xs: 12,
    },
    {
      name: "first_name",
      label: "First Name *",
      placeholder: "Enter your first name",
      rules: { required: "First Name is required" },
      icon: <PersonIcon />,
      sm: 6,
      xs: 12,
    },
    {
      name: "last_name",
      label: "Last Name *",
      placeholder: "Enter your last name",
      rules: { required: "Last Name is required" },
      icon: <PersonIcon />,
      sm: 6,
      xs: 12,
    },
    {
      name: "email",
      label: "Email *",
      placeholder: "Enter your email",
      rules: {
        required: "Email is required",
        pattern: {
          value: /^\S+@\S+$/i,
          message: "Enter a valid email address",
        },
      },
      icon: <EmailIcon />,
      sm: 6,
      xs: 12,
    },
    {
      name: "country_code",
      options: countryForCode,
      label: "Country Code *",
      placeholder: "Select Country Code",
      rules: {
        required: "Code is Required",
      },
      sm: 2,
      xs: 4,
    },

    {
      name: "phone",
      label: "Mobile *",
      placeholder: "Enter your mobile number",
      type: "Number",
      rules: {
        required: "Mobile number is required",
        pattern: {
          value: /^\d+$/,
          message: "Enter only numeric digits",
        },
      },
      icon: <PhoneIcon />,
      sm: 4,
      xs: 8,
    },
    {
      name: "discount",
      label: "Vendor Commission %",
      placeholder: "Enter Vendor Commission",
      rules: {
        required: "Vendor Commission is required",
        min: { value: 0, message: "Commission cannot be less than 0%" },
        max: { value: 100, message: "Commission cannot exceed 100%" },
      },
      type: "number",
      icon: <AccountBalanceIcon />,
      sm: 6,
      xs: 12,
    },
    {
      name: "address1",
      label: "Address1 *",
      placeholder: "Enter address",
      rules: { required: "Address is required" },
      icon: <LocationOnIcon />,
      sm: 6,
      xs: 12,
    },
    {
      name: "address2",
      label: "Address2",
      placeholder: "Enter address",
      icon: <LocationOnIcon />,
      sm: 6,
      xs: 12,
    },
    {
      name: "country",
      label: "Country *",
      placeholder: "Select country",
      rules: { required: "Country is required" },
      icon: <LocationOnIcon />,
      options: countryName,
      sm: 6,
      xs: 12,
    },
    {
      name: "state",
      label: "State *",
      placeholder: "Select state",
      rules: { required: "State is required" },
      icon: <LocationOnIcon />,
      options: stateName,
      sm: 6,
      xs: 12,
    },
    {
      name: "city",
      label: "City *",
      placeholder: "Select city",
      rules: { required: "City is required" },
      icon: <LocationOnIcon />,
      options: cityName,
      sm: 6,
      xs: 12,
    },

    {
      name: "pincode",
      label: "Pincode *",
      placeholder: "Enter pincode",
      type: "Number",
      rules: {
        required: "Pincode is required",
        pattern: {
          value: /^[0-9]+$/,
          message: "Enter a valid numeric pincode",
        },
      },
      icon: <LocationOnIcon />,
      sm: 6,
      xs: 12,
    },
    {
      name: "iata_reg_no",
      label: "IATA Registration Number",
      placeholder: "Enter IATA Reg number",

      icon: <AccountBalanceIcon />,
      sm: 6,
      xs: 12,
    },
    documentsField,
  ];

  const indiaSpecificFields = [
    {
      name: "pan_number",
      label: "PAN Number",
      placeholder: "Enter PAN number",
      rules: {
        validate: {
          atLeastOneRequired: (value) => {
            const hasGstin = !!formValue.gstin_number;
            if (!value && !hasGstin) {
              return "Either PAN or GSTIN is required";
            }
            if (value) {
              // Only validate format if a value is entered
              const validFormat = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value);
              if (!validFormat) {
                return "Invalid PAN format (e.g., ABCDE1234F)";
              }
            }
            return true;
          },
        },
      },
      icon: <AccountBalanceIcon />,
      sm: 6,
      xs: 12,
    },
    {
      name: "gstin_number",
      label: "GSTIN Number",
      placeholder: "Enter GSTIN number",
      rules: {
        validate: {
          atLeastOneRequired: (value) => {
            const hasPan = !!formValue.pan_number;
            if (!value && !hasPan) {
              return "Either PAN or GSTIN is required";
            }
            if (value) {
              // Only validate format if a value is entered
              const validFormat =
                /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
                  value
                );
              if (!validFormat) {
                return "Invalid GSTIN format (e.g., 22ABCDE1234F1Z5)";
              }
            }
            return true;
          },
        },
      },
      icon: <AccountBalanceIcon />,
      sm: 6,
      xs: 12,
    },
  ];

  const companyRegField = [
    {
      name: "company_reg_number",
      label: "Company Registration Number *",
      placeholder: "Enter Company Reg number",
      rules: {
        required: "Company Reg number is required",
      },
      icon: <AccountBalanceIcon />,
      sm: 6,
      xs: 12,
    },
  ];
  if (viewLoading) {
    return <Loading text="Loading Vendor details..." />;
  }
  return (
    <>
      <ToastContainer />
      <Box className="container">
        <Card elevation={3} sx={{ padding: 3 }}>
          <CardContent>
            <Typography variant="h5" className="form-heading">
              Edit Vendor
            </Typography>

            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              <Grid
                className="vendor-form-margin"
                container
                rowSpacing={4}
                columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 3 }}
              >
                {vendorFields.map((field, index) => (
                  <Grid item xs={field.xs} sm={field.sm} key={index}>
                    {field.customRender ? (
                      field.customRender({
                        name: field.name,
                        control: control,
                        label: field.label,
                        placeholder: field.placeholder,
                        startAdornment: field.icon,
                        rules: field.rules,
                        type: field.type,
                        options: field.options,
                        error: !!errors[field.name],
                        helperText: errors[field.name]?.message,
                      })
                    ) : (
                      <ControlledInputField
                        name={field.name}
                        control={control}
                        label={field.label}
                        placeholder={field.placeholder}
                        startAdornment={field.icon}
                        rules={field.rules}
                        type={field.type}
                        options={field.options}
                        error={!!errors[field.name]}
                        helperText={errors[field.name]?.message}
                      />
                    )}
                  </Grid>
                ))}

                {/* India-specific fields */}
                {countryId === 101 &&
                  indiaSpecificFields.map((field, index) => (
                    <Grid item xs={field.xs} sm={field.sm} key={index}>
                      <ControlledInputField
                        name={field.name}
                        control={control}
                        label={field.label}
                        placeholder={field.placeholder}
                        startAdornment={field.icon}
                        rules={field.rules}
                        error={!!errors[field.name]}
                        helperText={errors[field.name]?.message}
                      />
                    </Grid>
                  ))}

                {countryId !== 101 &&
                  companyRegField.map((field, index) => (
                    <Grid item xs={field.xs} sm={field.sm} key={index}>
                      <ControlledInputField
                        name={field.name}
                        control={control}
                        label={field.label}
                        placeholder={field.placeholder}
                        startAdornment={field.icon}
                        rules={field.rules}
                        error={!!errors[field.name]}
                        helperText={errors[field.name]?.message}
                      />
                    </Grid>
                  ))}

                <Grid item xs={12} sm={6}>
                  <StatusRadioGroup
                    name="status"
                    control={control}
                    defaultValue={
                      vendorData?.status === 1 ? "Active" : "Inactive"
                    }
                    rules={{ required: "Status is required" }}
                  />
                </Grid>
              </Grid>

              {/* Buttons */}
              <Grid item xs={12}>
                <Box className="button-container">
                  <CustomButton
                    variant="contained"
                    className="cancel-button"
                    type="button"
                    text={"Back"}
                     onClick={() => tab!==null?navigate(`/vendors`,{state:{tab:tab,page:page}}):navigate(-1)}
 
                  />
                  <CustomButton
                    variant="contained"
                    className="success-button"
                    type="submit"
                    loading={editLoading}
                    text={"update"}
                  />
                </Box>
              </Grid>
            </form>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
